import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "poetry_gate_token";

export const PasswordGate = ({ children }) => {
  const [unlocked, setUnlocked] = useState(null);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem(KEY);
    if (!token) {
      setUnlocked(false);
      return;
    }
    fetch(`${API}/gate/verify`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setUnlocked(r.ok))
      .catch(() => setUnlocked(false));
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const res = await fetch(`${API}/gate/unlock`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(typeof data.detail === "string" ? data.detail : "Wrong password");
        return;
      }
      localStorage.setItem(KEY, data.token);
      setUnlocked(true);
    } catch {
      setError("Something went wrong. Try again.");
    } finally {
      setBusy(false);
    }
  };

  if (unlocked === null) return <div className="gate" data-testid="gate-loading" />;
  if (unlocked) return children;

  return (
    <div className="gate" data-testid="password-gate">
      <form className="gate-form" onSubmit={submit}>
        <input
          className="byron gate-input"
          data-testid="gate-password-input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="password"
          autoFocus
          autoComplete="current-password"
        />
        <button
          className="byron gate-button"
          data-testid="gate-submit"
          type="submit"
          disabled={busy || !password}
        >
          enter
        </button>
        {error && (
          <p className="byron gate-error" data-testid="gate-error">
            {error}
          </p>
        )}
      </form>
    </div>
  );
};
